import { render } from "./FilterKabupatenKota.vue?vue&type=template&id=471a5110"
import script from "./FilterKabupatenKota.vue?vue&type=script&lang=js"
export * from "./FilterKabupatenKota.vue?vue&type=script&lang=js"
script.render = render

export default script